<template>
  <div v-if="hasData" id="stockStatusTooltip" class="tippy">
    <span v-if="stockMessage.description" id="stock-status-tooltip" v-tippy-html class="hidden">
      <span class="inline-block max-w-xs text-left">
        <span :class="stockMessage.cssClass">{{ stockMessage.label }}</span> - {{ stockMessage.description }}
      </span>
    </span>
    <span
      id="stockToolTip"
      v-tippy="
        stockMessage.description
          ? {
              html: '#stock-status-tooltip',
              theme: 'light-gray',
              arrow: true,
              interactive: true,
              arrowType: 'default',
              placement: 'top-end',
            }
          : undefined
      "
    >
      <span
        v-show="!loading"
        class="buying-zone__availability-msg"
        :class="{'cursor-default': !stockMessage.description}"
      >
        <span :class="stockMessage.cssClass">{{ stockMessage.label }}</span>
      </span>
    </span>
    <i v-if="stockMessage.description" class="material-icons md-14">info_outline</i>
  </div>
</template>
<script>
export default {
  name: 'PdpStockStatus',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    stockMessage: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasData() {
      return this.stockMessage && Object.keys(this.stockMessage).length > 0;
    },
  },
};
</script>
